const ITEMS = [
  "Premium Grooming",
  "Skin Fades & Tapers",
  "Springfield, VA",
  "Walk-Ins Welcome",
  "Hot Towel Shaves",
  "Beard Grooming",
  "Book Online",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-foreground/60 px-8">
          {item}
        </span>
        <span className="w-2 h-2 pole-stripes shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-border bg-card py-4"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
